import type { Entity, Persisted } from '@tunasong/schemas'
import { isFolderContainer } from '@tunasong/schemas'

/**
 * The space search was opened in (#2555): the top of the parent chain, or the open entity itself, when that is a space
 * (a top-level folder or band). An Unfiled item has none, so it offers no scope. Shared by the search dialog and the
 * editor's @-mention (Joni, #2562).
 */
export const scopeSpace = <T extends Persisted<Entity>>(current: T | undefined, parentChain: T[] | undefined) => {
  const top = parentChain?.[0] ?? current
  return top && isFolderContainer(top) ? top : undefined
}
